import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import InlineWarning from './inline-warning';
import translate from '../_utils/tools/translate';

const WARNING_MESSAGES = {
  COLLECT: () => `Please select a ${translate('collection point')}.`,
  PICKUP: () => `Please select a ${translate('store')} for pickup.`,
};

export default function MissingPickupLocationWarning({
  deliveryOptionType,
  className,
}) {
  const buildMessage =
    WARNING_MESSAGES[deliveryOptionType] || WARNING_MESSAGES.PICKUP;

  return (
    <InlineWarning
      className={classNames('missing-pickup-location-warning', className)}
      dataTestId="missing-pickup-location-warning">
      {buildMessage()}
    </InlineWarning>
  );
}

MissingPickupLocationWarning.propTypes = {
  deliveryOptionType: PropTypes.string,
  className: PropTypes.string,
};

MissingPickupLocationWarning.defaultProps = {
  deliveryOptionType: 'PICKUP',
  className: '',
};
